import HotelClientApi from '../../../../../api/HotelClientApi'

export const buildBillingClientPhone = (draft) => {
  const code = String(draft?.phone_country_code || '+216').trim()
  const local = String(draft?.billing_telephone || '').trim()
  if (!local) return null
  if (local.startsWith('+')) return local
  return `${code}${local.replace(/^0+/, '')}`
}

/**
 * Payload aligné moteur réservation hôtel (nom, prénom, type, segment, espace partenaire, téléphone, email).
 * @param {object} draft
 * @param {'physique'|'morale'} kind
 * @param {object|null} user
 * @param {string} [nomOverride]
 */
export const buildCreateBillingClientPayload = (draft, kind, user, nomOverride, t) => {
  const nom = String(nomOverride ?? draft?.billing_nom ?? '').trim()
  if (!nom) {
    throw new Error(
      t
        ? t('transferts.reservations.billing.nameRequired')
        : 'Le nom est requis pour créer un client',
    )
  }

  const isPhysique = kind === 'physique'
  const payload = {
    nom,
    prenom: isPhysique ? String(draft?.billing_prenom || '').trim() || null : null,
    type: isPhysique ? 'personne_physique' : 'personne_moral',
    segment: isPhysique ? 'B2C' : 'B2B',
    id_espace_partenaire: user?.user_partner_id ?? null,
    telephone1: buildBillingClientPhone(draft),
    email: String(draft?.billing_email || '').trim() || null,
  }

  if (!isPhysique) {
    payload.matricule_fiscal = String(draft?.billing_matricule_fiscal || '').trim() || null
    payload.adresse_facturation = String(draft?.billing_adresse_facturation || '').trim() || null
  }

  return payload
}

export const createBillingClientFromDraft = async (draft, kind, user, nomOverride, t) => {
  const payload = buildCreateBillingClientPayload(draft, kind, user, nomOverride, t)
  const response =
    kind === 'physique'
      ? await HotelClientApi.createPhysiqueClient(payload)
      : await HotelClientApi.createMoraleClient(payload)

  const expectedType = kind === 'physique' ? 'personne_physique' : 'personne_moral'
  const newClient = response?.client || {
    id: response?.id || response?.insertId,
    ...payload,
    type: expectedType,
  }

  if (!newClient?.id) {
    throw new Error(
      t
        ? t('transferts.reservations.billing.invalidApiResponse')
        : 'Réponse API invalide : identifiant client manquant',
    )
  }

  return newClient
}

export const findBillingClientByName = (pool, name) => {
  const needle = String(name || '').toLowerCase().trim()
  if (!needle || !Array.isArray(pool)) return null
  return (
    pool.find((client) => String(client.nom || client.name || '').toLowerCase().trim() === needle) ||
    null
  )
}
